import React, { FC } from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

// PropsTypeの定義
type PropsType = {
  title?: string;
  datasets: {
    name: string;
    areaValue: number;
    lineValue: number;
  }[];
  areaLabel: string;
  lineLabel: string;
  width?: number | string;
  height?: number;
  className?: string;
};

export const LineAndAreaChart: FC<PropsType> = ({
  title,
  datasets,
  areaLabel,
  lineLabel,
  width,
  height,
  className = "",
}) => {
  const categories = datasets.map((item) => item.name);
  const series = [
    {
      type: "area",
      name: areaLabel,
      data: datasets.map((item) => item.areaValue),
      color: "#0086CC",
      fillOpacity: 0.3,
    },
    {
      type: "line",
      name: lineLabel,
      data: datasets.map((item) => item.lineValue),
      color: "#FFD740",
      lineWidth: 2,
    },
  ];

  const options: Highcharts.Options = {
    chart: {
      type: "line",
      height,
      width,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: title || "",
    },
    xAxis: {
      categories: datasets.length > 0 ? categories : [""],
    },
    yAxis: {
      title: {
        text: "",
      },
      min: datasets.length > 0 ? undefined : 0,
      max: datasets.length > 0 ? undefined : 1,
    },
    plotOptions: {
      series: {
        allowPointSelect: true,
        cursor: "pointer",
      },
    },
    series: series as Highcharts.SeriesOptionsType[],
  };

  return (
    <div className={`min-h-[250px] max-w-full ${className}`}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};
